














































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Branch } from '@/api/model/branch'
import { User } from '@/api/model/user'
import { cloneDeep, isEqual } from 'lodash'
import { TriggeredReferral } from '@/api/model/triggered-referral'
import AvatarHeader from '@/components/virtual-colleague/AvatarHeader.vue'
import { InputSelectOption } from '@/helpers/options'

@Component({
    components: { AvatarHeader },
})
export default class CreateAutoLeadFormStep3 extends Vue {
    @Prop({ required: true }) readonly value!: TriggeredReferral
    editingValue: TriggeredReferral = null

    @Watch('value', {immediate: true})
    onValueChanged() {
        this.editingValue = cloneDeep(this.value)
    }

    @Watch('editingValue.referralReferredByBranch')
    @Watch('editingValue.referralReferredByPreference')
    @Watch('editingValue.referralReferredBy')
    @Watch('editingValue.referralAssignedToBranch')
    @Watch('editingValue.referralAssignedTo')
    @Watch('editingValue.maxDaysForExistingReferrals')
    onEditingValueChanged() {
        if (isEqual(this.editingValue, this.value)) {
            return
        }

        this.$emit('update:value', this.editingValue)
    }

    @Watch('pipeline')
    autoSelectFirstAssignedToBranch(): void {
        if (this.availableAssignedToBranches.length === 1) {
            this.editingValue.referralAssignedToBranch = this.availableAssignedToBranches[0]
        }
    }

    get availableReferredByBranches(): Branch[] {
        return this.$currentCompany.getAvailableBranches()
    }

    get availableReferredBy(): User[] {
        if (!this.editingValue.referralReferredByBranch) {
            return []
        }

        return this.$currentCompany.getAvailableUsers({
            branch: this.editingValue.referralReferredByBranch,
        })
    }

    get availableAssignedToBranches(): Branch[] {
        if (!this.editingValue.referralPipeline) {
            return []
        }

        return this.editingValue.referralPipeline.branches
            .sort((a, b) => a.name.localeCompare(b.name))
    }

    get availableAssignedTo(): User[] {
        if (!this.isOwnPipeline || !this.editingValue.referralAssignedToBranch) {
            return []
        }

        return this.$currentCompany.getAvailableUsers({
            branch: this.editingValue.referralAssignedToBranch,
        })
    }

    get isOwnPipeline(): boolean {
        if (!this.editingValue.referralPipeline) {
            return false
        }

        return this.editingValue.referralPipeline?.company?.id === this.$currentCompany?.id
    }

    get avatarHeaderText() {
        return this.$t('virtualColleague.autoLead.avatarHeader.stepThree', {
            pipeline: this.value.referralPipeline.name,
            source: this.value.referralNewSource.name,
        })
    }

    get isTaskType(): boolean {
        return this.value.triggerType === 'taakTypes'
    }

    get isAgendaType(): boolean {
        return this.value.triggerType === 'agendaTypes'
    }

    get currentTaskOrAgendaLabel(): string {
        switch (true) {
            case this.isTaskType: return 'taak'
            case this.isAgendaType: return 'afspraak'
            default: return ''
        }
    }

    get referralReferredByPreferenceOptions(): InputSelectOption[] {
        const options =  [
            {
                value: null,
                label: this.$t('virtualColleague.autoLead.referralReferredByPreferenceOptions.default').toString(),
            },
        ]

        if (this.isTaskType || this.isAgendaType) {
            options.push(
                {
                    value: 'creator',
                    label: this.$t('virtualColleague.autoLead.referralReferredByPreferenceOptions.creator', { type: this.currentTaskOrAgendaLabel }).toString(),
                },
                {
                    value: 'assignee',
                    label: this.$t('virtualColleague.autoLead.referralReferredByPreferenceOptions.assignee', { type: this.currentTaskOrAgendaLabel }).toString(),
                },
            )
        }

        return options
    }
}
